<div class="container">
  <div class="form-wrapper light-control-host">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <p-fluid>
        <!-- <div class="p-field" *ngIf="showCategory">
        <label for="category">Category</label>
        <ng-container *ngIf="categoryOptions.length < 2; else manyCategories">
          <input id="message" readonly type="text" pInputText formControlName="category" class="full-width"
            [value]="categoryOptions[0]?.value ?? 'outage'" />
        </ng-container>

        <ng-template #manyCategories>
          <p-select [options]="categoryOptions" formControlName="category" placeholder="Select a Category">
          </p-select>
        </ng-template>

        <div *ngIf="form.controls.category.invalid && form.controls.category.touched" class="p-error">Category is
        required</div>
      </div> -->

        <div class="p-field">
          <label for="message">Message (HTML)</label><br />

          <textarea id="message" formControlName="message" rows="9" cols="30" pTextarea [autoResize]="true"> </textarea>

          @if (form.controls.message.invalid && form.controls.message.touched) {
            <div class="p-error">Message (HTML) is required</div>
          }
        </div>

        <div class="p-field p-field-visible">
          <label for="visible">Visible</label>
          <p-toggleswitch formControlName="visible"></p-toggleswitch>
          @if (form.controls.visible.invalid && form.controls.visible.touched) {
            <div class="p-error">Visible is required</div>
          }
        </div>

        <div class="p-field">
          <button
            style="max-width: 10rem"
            type="submit"
            pButton
            label="Save"
            [disabled]="form.invalid || loading"
            pRipple
            [loading]="loading"
          ></button>
        </div>
      </p-fluid>
    </form>
  </div>
</div>
